import listData from '@/components/navbar'
// console.log(listData);
const state = {
	navList: listData
}
const mutations = {
	setNavBar: (state, data) => {
		state.navList = data;
	}
}
export default {
	state,
	mutations
}
